import { render } from "./CategoryListPage.vue?vue&type=template&id=6e9f17da&ts=true"
import script from "./CategoryListPage.vue?vue&type=script&lang=ts"
export * from "./CategoryListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__